export default __webpack_public_path__ + "static/media/Gaussian_5nm.507ac671.png";